/**
 * Shared constants and copy for Kai (AI Assistant) across RCM services.
 * Use these for Copilot vs CoWorker labeling, mode descriptions, and analytics.
 * See RcmPlatform/COWORKER_COPILOT_DESIGN.md for strategy.
 */

/** Display name for the AI assistant (all services) */
export const AI_ASSISTANT_NAME = 'Kai';

/** Label for the coworker/autonomous tier (queue assignee, analytics, etc.) */
export const AI_COWORKER_LABEL = `${AI_ASSISTANT_NAME} – AI Coworker`;

/** Short label for queue cards and dropdowns */
export const AI_COWORKER_SHORT_LABEL = 'Kai – AI Coworker';

/** Label for the copilot/suggest-and-approve tier */
export const AI_COPILOT_LABEL = `${AI_ASSISTANT_NAME} – AI Copilot`;

/** Mode identifiers for settings and UI */
export const AI_MODE = {
  COPILOT: 'copilot',
  COWORKER: 'coworker',
};

/** Human-readable mode labels for banners and settings */
export const AI_MODE_LABELS = {
  [AI_MODE.COPILOT]: 'Suggest & approve',
  [AI_MODE.COWORKER]: 'Auto mode',
};

/** Descriptions for tooltips or help text */
export const AI_MODE_DESCRIPTIONS = {
  [AI_MODE.COPILOT]: 'Kai suggests actions; you review and approve before anything is applied.',
  [AI_MODE.COWORKER]: 'Kai runs autonomously; actions are logged and available in the review queue.',
};

/** Default value for "assign to AI" in work queues (e.g. dropdown value) */
export const AI_ASSIGNEE_VALUE = 'ai';
